export default [
  {
    path: "/main/integrador/custom-delivery-details",
    meta: {
      tag: "custom_delivery_details",
      name: "Editar | Detalhes da entrega",
      breadcrumb: "Editar Detalhes da entrega",
      menu: "settings",
    },
    component: () => import(/* webpackChunkName: "custom-delivery-details" */ "@/views/main/settings/integrador/custom-delivery-details/Edit.vue"),
  },
];
